import { ScriptsView } from "./views/ScriptsView";

export const ScriptConfiguration = () => {
  return (
    <>
      <ScriptsView />
    </>
  );
};
